import GLOBAL_ACTION from '@naruto/naruto-reducers/src/reducers/global/events';
import {
  SetGlobalContentInitialAction,
  SetGlobalLoadingAction,
  SetGlobalSideBarAction,
  SetGlobalSideBarStaticAction,
  SetGlobalHeaderAction,
  SetGlobalThemeAction,
  SetGlobalHistoriesAction,
  SetGlobalRoleSelectAction,
  SetGlobalFontScaleAction,
  SetGlobalLangAction
} from './types';

/* Global */
export const SET_GLOBAL_INITIALIZE = (): SetGlobalContentInitialAction => ({
  type: GLOBAL_ACTION.SET_GLOBAL_INITIALIZE
});
export const SET_GLOBAL_LOADING = ({ loading }: { loading: boolean }): SetGlobalLoadingAction => ({
  type: GLOBAL_ACTION.SET_GLOBAL_LOADING,
  loading
});
export const SET_GLOBAL_SIDE_BAR = ({ open }: { open: boolean }): SetGlobalSideBarAction => ({
  type: GLOBAL_ACTION.SET_GLOBAL_SIDE_BAR,
  open
});
export const SET_GLOBAL_SIDE_BAR_STATIC = ({ open }: { open: boolean }): SetGlobalSideBarStaticAction => ({
  type: GLOBAL_ACTION.SET_GLOBAL_SIDE_BAR_STATIC,
  open
});
export const SET_GLOBAL_HEADER = ({ open }: { open: boolean }): SetGlobalHeaderAction => ({
  type: GLOBAL_ACTION.SET_GLOBAL_HEADER,
  open
});
export const SET_GLOBAL_THEME = ({ theme }: { theme: string }): SetGlobalThemeAction => ({
  type: GLOBAL_ACTION.SET_GLOBAL_THEME,
  theme
});
export const SET_GLOBAL_HISTORIES = ({ histories }: { histories: string[] }): SetGlobalHistoriesAction => ({
  type: GLOBAL_ACTION.SET_GLOBAL_HISTORIES,
  histories
});
export const SET_GLOBAL_ROLE_SELECT = ({ select }: { select: boolean }): SetGlobalRoleSelectAction => ({
  type: GLOBAL_ACTION.SET_GLOBAL_ROLE_SELECT,
  select
});
export const SET_GLOBAL_FONT_SCALE = ({ scale }: { scale: number }): SetGlobalFontScaleAction => ({
  type: GLOBAL_ACTION.SET_GLOBAL_FONT_SCALE,
  scale
});
export const SET_GLOBAL_LANG = ({ lang }: { lang: string }): SetGlobalLangAction => ({
  type: GLOBAL_ACTION.SET_GLOBAL_LANG,
  lang
});
